var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showContextMenuVisible)?_c('div',{staticClass:"mousemenu-box",style:(`top:${_vm.point.y}px;left:${_vm.point.x}px;`)},[_c('ul',_vm._l((_vm.contextMenuList),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.menuClickEvent(item.key)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }